import reportService from "../services/report.service";

async function call(today, tomorrow, employeeIds) {
  console.log("calling functions in parallel");
  let promises = [];
  let result = [];

  //   const employeeIds = []; // this.$store.state.general.departmentData

  console.log("start:", new Date());

  employeeIds.forEach((id) => {
    promises.push(parallelApiCall(today, tomorrow, id));
  });

  const data = await Promise.all(promises);
  data.forEach(({ data }) => {
    result = [...result, data];
  });

  console.log(new Date());
  console.log(result);
}

function parallelApiCall(today, tomorrow, employeeId) {
  return reportService.GetNormalizedAccessDataByTimeRange(
    today, //new Date("2022-06-18T00:00:00"),
    tomorrow, //new Date("2022-06-19T00:00:00"),
    employeeId,
    null
  );
}

export { call };
